import React from 'react';
import _ from 'lodash';

// @see https://stackoverflow.com/questions/38510443/how-to-use-an-svg-file-in-a-svgicon-in-material-ui
import { makeStyles } from '@material-ui/styles';
import Icon from '@material-ui/core/Icon';

import blueSvg from 'assets/icons/amap/issue-blue.svg';
import whiteSvg from 'assets/icons/amap/issue-white.svg';

const useStyles = makeStyles({
  imageIcon: {
    display: 'flex',
    height: 'inherit',
    width: 'inherit'
  }
});

export default function(props) {
  const classes = useStyles();
  const imageColor = _.get(props, 'icolor', 'white');
  const image = imageColor === 'blue' ? blueSvg : whiteSvg;
  return (
    <Icon {...props}>
      <img className={classes.imageIcon}
           src={image} alt="" // @todo
      />
    </Icon>
  );
}